module.exports = __webpack_public_path__ + "img/helags001.69205f5a.jpg";